// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"a0e48cf9","213":"fcfab765","301":"a4241e43","444":"41d19b20","587":"f3521069","682":"bb231870","732":"c6b68edf"}[chunkId] + ".chunk.js";
};